namespace $.$$ {
	export class $optimade_zero_search_tag extends $.$optimade_zero_search_tag {
		
		html_label() {
			return `<div>${this.label()}</div>`
		}
		
	}
}
